import { IPaisDTO, PaisDTO } from "./Pais.DTO";
import { CiudadDTO, ICiudadDTO } from "./Ciudad.DTO";
import { TagDTO } from "./Tag.DTO";
import { InvestigacionDTO } from "./Investigacion.DTO";
import { GrupoDTO } from "./Grupo.DTO";
import { Nilable } from "@shared/utils";
import { Mapper } from "@shared/interfaces/mapper";

export interface IGrupoFiltroDTO {
    id: Nilable<number>;
    name: string;
    campaign: number;
    max_users: number;
    enabled: boolean;
    tags: number[];
    target_country: Nilable<IPaisDTO>;
    include_active_users: boolean;
    target_city: Nilable<ICiudadDTO>;
    country: Nilable<number>;
}

export class GrupoFiltroDTO implements Mapper<IGrupoFiltroDTO, GrupoFiltroDTO> {
    public id: Nilable<number>;
    public nombre = "";
    public grupo = new GrupoDTO();
    public usuariosMaximos = 0;
    public activado = true;
    public tags: TagDTO[] = [];
    public targetPais: Nilable<PaisDTO>;
    public incluirUsuariosActivos = true;
    public targetCiudad: Nilable<CiudadDTO>;

    constructor(json: Nilable<Partial<IGrupoFiltroDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IGrupoFiltroDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.campaign != null) {
            this.grupo = new GrupoDTO({ id: json.campaign });
        }
        if (json.max_users != null) {
            this.usuariosMaximos = json.max_users;
        }
        if (json.enabled != null) {
            this.activado = json.enabled;
        }
        if (json.tags != null) {
            this.tags = json.tags.map(tagId => new TagDTO({ id: tagId }));
        }
        if (json.target_country != null) {
            this.targetPais = new PaisDTO(json.target_country);
        }
        if (json.include_active_users != null) {
            this.incluirUsuariosActivos = json.include_active_users;
        }
        if (json.target_city != null) {
            this.targetCiudad = new CiudadDTO(json.target_city);
        }
    }

    public asignarNombre(investigacion: InvestigacionDTO, grupo: GrupoDTO) {
        this.nombre = `#${investigacion.id} ${grupo.nombre}`;

        if (this.nombre.length > 50) {
            this.nombre = this.nombre.slice(0, 49);
        }
    }

    public obtenerJSON(): IGrupoFiltroDTO {
        return {
            id: this.id,
            name: this.nombre,
            campaign: this.grupo.id,
            max_users: this.usuariosMaximos,
            enabled: this.activado,
            tags: this.tags.map(tag => tag.id).filter(Boolean),
            target_country: this.targetPais?.toJSON() ?? null,
            include_active_users: this.incluirUsuariosActivos,
            target_city: this.targetCiudad?.toJSON() ?? null,
            country: this.targetPais?.id ?? null
        };
    }

    public clone(): GrupoFiltroDTO {
        const clon = new GrupoFiltroDTO(this.obtenerJSON());
        clon.tags = this.tags.map(tag => new TagDTO(tag.toJSON()));
        return clon;
    }
}
